import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import RouteErrorBoundary from './v2/RouteErrorBoundary'
import './index.css'
import './loadBrandFonts'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Last resort (B6 audit, 2026-09-04): anything the v2 shell's own
        boundary cannot catch — the router, the auth provider, the v1
        layout — lands here instead of a blank document. The doors are
        plain anchors: no router below this point. */}
    <RouteErrorBoundary>
      <App />
    </RouteErrorBoundary>
  </StrictMode>
)
